import React, { useEffect, useState } from 'react';
import { InspectionStore } from '../../contexts/InspectionContext';
import ProjectContext from '../../contexts/ProjectContext';
import projectApi from '../../utils/api/project';
import { useRouteMatch } from 'react-router-dom';
import inspectionTemplateApi from '../../utils/api/inspectionTemplate';
import AppContext from '../../contexts/AppContext';
/**
 *
 */

 
const FullScreenLayout = ({ children }) => {
  const match = useRouteMatch();
  const [projectDocs, setProjectDocs] = useState();
  const [templateName, setTemplateName] = useState();
  const [isDownloaded, setIsDownloaded] = useState(false);
  const appContext= React.useContext(AppContext);

  useEffect(async () => {
    const data = await projectApi.getDocs(match.params.projectId);

    setProjectDocs(data);

    const getProject = await projectApi.get(match.params.projectId);

    setIsDownloaded(getProject && isDownloadedByLoggedInUser(getProject));

    const getName =
      getProject && (await inspectionTemplateApi.get(getProject.inspection_template_id));

    setTemplateName(getName);
  }, []);


  const isDownloadedByLoggedInUser = (project) => {

    if(!navigator.onLine){
      return true;
    }
    
    if (project && project.offline_projects?.length) {
      const offlineProjects = project.offline_projects.filter(
        (offlineProject) => offlineProject.user_id ===  appContext.get('user').id
      );

      if (offlineProjects.length > 0) {
        return true;
      } else {
        return false;
      }
     
    }
    else {
      return true;
    }
  }

  
  return (
    <ProjectContext.Provider
      value={{
        projectDocs,
        setProjectDocs,
        template: templateName && templateName.name,
        isDownloaded
      }}
    >
      <InspectionStore>
        <div className='layout layout--fullscreen'>{children}</div>
      </InspectionStore>
    </ProjectContext.Provider>
  );
};

export default FullScreenLayout;